// extracted by mini-css-extract-plugin
export default {"textInput":"textInput-pLGnY9hH"};